class Accordion {

    init(element) {
        this.buttonNodes = element.querySelectorAll('[data-accordion-button]');

            this.buttonNodes.forEach( (buttonNode) => {

            var controlledNode = false;
        
            var id = buttonNode.getAttribute('aria-controls');
        
            if (id) {
              var controlledNode = document.getElementById(id);
            }
        
            buttonNode.setAttribute('aria-expanded', 'false');
            this.hideContent(controlledNode);
        
            buttonNode.addEventListener('click', (event) => { 
              event.stopImmediatePropagation();
              this.onClick(buttonNode, controlledNode)
            } );
            buttonNode.addEventListener('focus', (event) => { this.onFocus(buttonNode)} );
            buttonNode.addEventListener('blur', (event) => { this.onBlur(buttonNode)} );
        })

        
      }

    showContent(controlledNode) {
        if (controlledNode) {
          controlledNode.style.display = 'block';
        }
    }

    hideContent(controlledNode) {
        if (controlledNode) {
          controlledNode.style.display = 'none';
        }
      }


    toggleExpand(buttonNode, controlledNode) {
        if (buttonNode.getAttribute('aria-expanded') === 'true') {
          buttonNode.setAttribute('aria-expanded', 'false');
          this.hideContent(controlledNode);
        } else {
          buttonNode.setAttribute('aria-expanded', 'true');
          this.showContent(controlledNode);
        }
      }

      onClick(buttonNode, controlledNode) {
        this.toggleExpand(buttonNode, controlledNode);
      }
    
      onFocus(buttonNode) {
        buttonNode.classList.add('focus');
      }
    
      onBlur(buttonNode) {
        buttonNode.classList.remove('focus');
      }

}

export const accordion = new Accordion();